import type { DateOnlyDateRange } from "@design-system/DateRangeFilter/DateRangeFilterNext.lib";
import type { DensityChartWindow } from "@design-system/DensityChart/DensityChart.lib";

/** The picked range; an open `end` means "up to the server's today". */
export interface AgentUsageSelection {
    start?: string;
    end?: string;
}

export const toMonthStart = (dateOnly: string) => `${dateOnly.slice(0, 7)}-01`;

export const yearStart = (today: string) => `${today.slice(0, 4)}-01-01`;

interface ToPickerSelectionParams {
    range: DateOnlyDateRange;
    isAllTime: boolean;
    historyStart: string;
    today: string;
}

/**
 * The picker's range as a selection: All time starts at the history start,
 * and an end past today (This year's Dec 31) is left open so the server's
 * today bounds the range.
 */
export function toPickerSelection({
    range,
    isAllTime,
    historyStart,
    today,
}: ToPickerSelectionParams): AgentUsageSelection {
    if (isAllTime) {
        return { start: historyStart };
    }
    return {
        start: range.start ?? historyStart,
        end: range.end && range.end <= today ? range.end : undefined,
    };
}

interface ToUsageWindowParams {
    selection: AgentUsageSelection;
    historyStart: string;
    today: string;
}

/** The selection as the chart's window, both ends closed. */
export function toUsageWindow({
    selection,
    historyStart,
    today,
}: ToUsageWindowParams): DensityChartWindow {
    return {
        start: selection.start ?? historyStart,
        end: selection.end ?? today,
    };
}
